module.exports = {
  footerText: "Copyright run-script.com © 2020",
};
